"use strict";

jQuery( document ).ready( ( $ ) => {

	const InterestsList = function( $parentTerm ) {
		const $el = $parentTerm;
		const $parentCheckbox = $el.find( '> input[type="checkbox"]');
		const $children = $el.find( 'li input[type="checkbox"]' );

		this.setParentCheckboxValue = ( value ) => {
			$children.each( function() {
				$(this).prop( 'checked', value );
			})
		}

		this.init = () => {
			$parentCheckbox.on( 'change', ( { target } ) => {
				this.setParentCheckboxValue( $(target).is( ':checked' ) );
			} );
		}
	}


	const $preferencesList = $('.mc-preferences__interests-list');
	if ( ! $preferencesList.length ) {
		return;
	}

	$preferencesList.each( function() {
		$(this).find( 'li.mc-preferences__interests-list__parent' ).each( function() {
			const $parentTerm = $(this);
			const interestsList = new InterestsList( $parentTerm );
			interestsList.init();
		} )
	} );
} );